/* eslint-disable react/prop-types */
import React from 'react';
import 'moment/min/locales';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const InpiPuntu = '926246828'

export const Receipt = ({
  data, company, user, checked, noEmail,
}) => {
  const fields = [
    {
      name: 'CNPJ: ',
      prop: 'cnpj',
      from: company[0],
    },
    {
      name: 'LOCAL: ',
      prop: 'address',
      from: data,
    },
    {
      name: 'TIPO: ',
      prop: 'type',
      from: data,
    },
    {
      name: 'NOME: ',
      prop: 'employeeName',
      from: user,
    },
    {
      name: 'CPF: ',
      prop: 'cpf',
      from: data,
    },
    {
      name: 'PIS: ',
      prop: 'pis',
      from: company[0],
    },
  ];

  const [state, setState] = React.useState({
    checked: false,
  });

  const handleChange = name => (event) => {
    checked(event.target.checked);
    setState({ ...state, [name]: event.target.checked });
  };

  function renderLabel() {
    return (

      <span>
        Enviar por email
        <span style={{ color: '#8898AA' }}> ({company[0].email ? company[0].email.toLowerCase() : ''})</span>
      </span>
    );
  }

  return (
    <div>
      <div style={{ backgroundColor: '#FEFFEE', maxWidth: '400px', padding: '20px' }}>
        <div style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '20px' }}>
          {/* Ver comprovante */}
          COMPROVANTE DE REGISTRO DE PONTO DO TRABALHADOR
        </div>

        <div style={{ marginTop: '', fontSize: 14 }}>
          <span style={{ fontWeight: 'bold' }}>RAZÃO SOCIAL:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{company[0].businessName}</span>
        </div>
        
        {/* <div style={{ marginTop: '5px', marginBottom: '5px', fontSize: 14 }}>
          <span style={{ fontWeight: 'bold' }}>NSR:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{data.nsr}</span>
        </div> */}

        {
          fields.map(field => (
            <div style={{ flexDirection: 'row', marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>
                {field.name}
                <span style={{ fontWeight: 'normal' }}>
                  {
                    // eslint-disable-next-line no-nested-ternary
                    field.prop !== 'type' ?
                      (field.from[field.prop] && field.from[field.prop].length ? field.from[field.prop] : 'NÃO CADASTRADO') :
                      (field.from[field.prop] === 'O' ? 'Saída' : 'Entrada')
                  }
                </span>
              </span>
            </div>
          ))
        }

        <div style={{ flexDirection: 'row', marginBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>DATA:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{data.dtRegister}</span>

          <span style={{ fontWeight: 'bold', marginLeft: '60px' }}>{'   '}HORA:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{data.hour}</span>

        </div>

        <div style={{ marginTop: '40px' }}>
          <span style={{ marginRight: 43, fontSize: 14 }}>Puntu - Ponto Digital</span>
          <span style={{ fontSize: 14 }}>INPI:{InpiPuntu}</span>
        </div>

        <div
          style={{
            fontSize: 10,
            alignment: 'center',
            opacity: 0.5,
            marginTop: '20px',
          }}
        >
          {/* <div style={{ textAlign: 'center' }}>Hash de Segurança:</div>
         <span>e35dc61bcdc3c38cca948951a228a8b0d48dcf6a6ddf6f024a1c5939d3f90429</span> */}
        </div>
      </div>

      {noEmail ? '' :
        <div style={{ padding: '15px 15px 0px 15px', maxWidth: '400px' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.checked}
                onChange={handleChange('checked')}
                value="checked"
                color="primary"
                inputProps={{
                  'aria-label': 'primary checkbox',
                }}
              />
            }
            label={renderLabel()}
          />
        </div>}
    </div>
  );
};
